module.exports = __webpack_public_path__ + "img/noGoods.f9be3a24.png";